import React, { useState } from "react";
import Header from "../../../Components/comman/Header";
import SideMenu from "../SideMenu";
import { Tab } from "react-bootstrap";
import Profile from "./Profile";
import MobileHeader from "../../../Components/comman/MobileHeader";
import CustomLoader from "../../../Components/comman/Loader/CustomLoader";

const BrandAccount = () => {
  const[isLoading , setIsLoading] = useState(false);
  return (
    <div className="brand-dashboard-wrapper">
      <Header />
      <MobileHeader/>
      <div className="brand-dashboard-inner ">
        <Tab.Container activeKey={`account`}>
          <SideMenu />
          <CustomLoader visible={isLoading} />
          <div className="brand-dashboard-content-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"account"}>
                <Profile />
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
};

export default BrandAccount;
